module.exports = __webpack_public_path__ + "static/builder-four@2x-bb9d97564d75ee8bf05ea38a4bbdc2ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/ios-app-builder/builder-four@2x.jpg
// module id = 2649
// module chunks = 168707334958949